let api = {
    id: "d329om6g50",
    version: "v1"
}

let apiUrl = {
    url: `https://${api.id}.execute-api.sa-east-1.amazonaws.com/dev`,
}

export const environment = {
    appUrl: 'https://dev.lgpdlab.com.br',
    apiUrl : `https://${api.id}.execute-api.sa-east-1.amazonaws.com/dev/${api.version}`,
    colabUser: {
        listAll: `${apiUrl.url}/user-management/v1/colab-user`,
        getById: `${apiUrl.url}/user-management/v1/colab-user`,
        update: `${apiUrl.url}/user-management/v1/colab-user/{id}`,
        create: `${apiUrl.url}/user-management/v1/colab-user`,
        delete: `${apiUrl.url}/user-management/v1/colab-user/{id}`,
    },
    userManagementUrl : {
        userAuthenticate: `${apiUrl.url}/user-management/v1/user/authenticate`,
        userInfos: `${apiUrl.url}/user-management/v1/user/infos`,
        updateNameEmail: `${apiUrl.url}/user-management/v1/user/{id}`,
        updatePassword: `${apiUrl.url}/user-management/v1/user/update-password`,
        userRegistration: `${apiUrl.url}/user-management/v1/user/register`,
        emailValidation: `${apiUrl.url}/user-management/v1/user/emailValidate`,
        sendEmailVerification: `${apiUrl.url}/user-management/v1/user/send-email-verification`,
        recoveryPassword: `${apiUrl.url}/user-management/v1/user/recovery-password`,
        redefinePassword: `${apiUrl.url}/user-management/v1/user/redefine-password`
    },
    accountManagementUrl : {
        accountCreate: `${apiUrl.url}/account-management/v1/account/register`,
        accountUpdate: `${apiUrl.url}/account-management/v1/account/update`,
        accountDelete: `${apiUrl.url}/account-management/v1/account/delete/{id}`,
        listAllAccounts: `${apiUrl.url}/account-management/v1/account/:userid/listAll`,
        retrievePrivacyConfigs: `${apiUrl.url}/account-management/v1/privacy-center/{accountId}/configs`,
        updatePrivacyConfigs: `${apiUrl.url}/account-management/v1/privacy-center/{accountId}`,
        sendPrivacyOrder: `${apiUrl.url}/account-management/v1/privacy-order/{accountId}`,
        getOrders: `${apiUrl.url}/account-management/v1/privacy-order/{accountId}/paginated`,
        updateOrder: `${apiUrl.url}/account-management/v1/privacy-order/{orderId}`,
        incident: {
            listAll: `${apiUrl.url}/account-management/v1/incident/{accountId}/paginated`,
            update: `${apiUrl.url}/account-management/v1/incident/{accountId}/{id}`,
            create: `${apiUrl.url}/account-management/v1/incident/{accountId}`,
            delete: `${apiUrl.url}/account-management/v1/incident/{accountId}/{id}`
        },
        maturityForm: {
            listAll: `${apiUrl.url}/account-management/v1/maturity-form/{accountId}`,
            update: `${apiUrl.url}/account-management/v1/maturity-form`,
            finish: `${apiUrl.url}/account-management/v1/maturity-form/finish`,
            initialize: `${apiUrl.url}/account-management/v1/maturity-form/{accountId}/initialize`,
            delete: `${apiUrl.url}/account-management/v1/maturity-form/{accountId}/{id}`,
            downloadReport: `${apiUrl.url}/account-management/v1/maturity-form/{accountId}/{id}/report`
        },
        kanbanManagement: {
            listAll: `${apiUrl.url}/account-management/v1/kanban/cards/{accountId}`,
            getCardById: `${apiUrl.url}/account-management/v1/kanban/cards/{accountId}/{id}`,
            update: `${apiUrl.url}/account-management/v1/kanban/cards/{accountId}/{id}`,
            create: `${apiUrl.url}/account-management/v1/kanban/cards`,
            delete: `${apiUrl.url}/account-management/v1/kanban/cards/{accountId}/{id}`
        },
        repository: {
            createFolder: `${apiUrl.url}/account-management/v1/repository-folders`,
            insertFile: `${apiUrl.url}/account-management/v1/repository-folders/{folderId}/files`,
            listAll: `${apiUrl.url}/account-management/v1/repository-folders/{accountId}`,
            listAllFiles: `${apiUrl.url}/account-management/v1/repository-files/folder/{folderId}`,
            listAllFilesByAccount: `${apiUrl.url}/account-management/v1/repository-files/{accountId}`,
            updateFile: `${apiUrl.url}/account-management/v1/repository-files`,
            deleteFile: `${apiUrl.url}/account-management/v1/repository-files/{id}`,
            deleteFolder: `${apiUrl.url}/account-management/v1/repository-folders/{folderId}`
        },
        formularios: {
            create: `${apiUrl.url}/account-management/v1/formularios`,
            listAll: `${apiUrl.url}/account-management/v1/formularios`, 
            listPerguntas: `${apiUrl.url}/account-management/v1/formularios/{id}/perguntas`,
            listPerguntasByUser: `${apiUrl.url}/account-management/v1/formularios/{id}/{userId}/perguntas`,
            createPergunta: `${apiUrl.url}/account-management/v1/formularios/{id}/perguntas`,
            deletePergunta: `${apiUrl.url}/account-management/v1/formularios/{id}/perguntas/{perguntaId}`,
            submitFormulario: `${apiUrl.url}/account-management/v1/respostas-formularios`,
            respostasFormulario: `${apiUrl.url}/account-management/v1/respostas-formularios/{formId}/{accountId}`,
            answerRisk: `${apiUrl.url}/account-management/v1/respostas-formularios`,
            sentEmail: `${apiUrl.url}/account-management/v1/formularios/send-email`
        }
    },
    dataMapping: {
        departmentUrl: {
            create: `${apiUrl.url}/data-mapping/v1/department/register`,
            update: `${apiUrl.url}/data-mapping/v1/department/{id}`,
            delete: `${apiUrl.url}/data-mapping/v1/department/{id}`,
            listAllDepartment: `${apiUrl.url}/data-mapping/v1/department/{accountId}/listAll`
        },
        thirdUrl: {
            create: `${apiUrl.url}/data-mapping/v1/third/register`,
            update: `${apiUrl.url}/data-mapping/v1/third/{id}`,
            delete: `${apiUrl.url}/data-mapping/v1/third/{id}`,
            listAllThird: `${apiUrl.url}/data-mapping/v1/third/{accountId}/listAll`
        },
        processUrl: {
            create: `${apiUrl.url}/data-mapping/v1/process/register`,
            update: `${apiUrl.url}/data-mapping/v1/process/{id}`,
            delete: `${apiUrl.url}/data-mapping/v1/process/{id}`,
            listAll: `${apiUrl.url}/data-mapping/v1/process/{accountId}/listAll`,
            listAllPaginated: `${apiUrl.url}/data-mapping/v1/process/{accountId}/listAllPaginated`,
            tools: `${apiUrl.url}/data-mapping/v1/process/tools/{accountId}`
        },
        riskUrl: {
            create: `${apiUrl.url}/data-mapping/v1/risk/register`,
            update: `${apiUrl.url}/data-mapping/v1/risk/{id}`,
            delete: `${apiUrl.url}/data-mapping/v1/risk/{id}`,
            listAll: `${apiUrl.url}/data-mapping/v1/risk/{userId}/listAll`,
            listAllPaginated: `${apiUrl.url}/data-mapping/v1/risk/{userId}/listAllPaginated`
        },
        riskAppointment: {
            create: `${apiUrl.url}/data-mapping/v1/risk-appointment/register`,
            dashInfos: `${apiUrl.url}/data-mapping/v1/risk-appointment/dashboard-info/{accountId}`,
            listAll: `${apiUrl.url}/data-mapping/v1/risk-appointment/list`,
            listingAllByAccount: `${apiUrl.url}/data-mapping/v1/risk-appointment/listAll/{accountId}`,
            update: `${apiUrl.url}/data-mapping/v1/risk-appointment/{id}`,
            delete: `${apiUrl.url}/data-mapping/v1/risk-appointment/{id}`
        },
        actionPlan: {
            listAll: `${apiUrl.url}/data-mapping/v1/action-plan/{accountId}/listAll`,
            update: `${apiUrl.url}/data-mapping/v1/action-plan/{id}`,
            delete: `${apiUrl.url}/data-mapping/v1/action-plan/{id}`,
            dashInfos: `${apiUrl.url}/data-mapping/v1/action-plan/dashboard-info/{accountId}`,
            getById: `${apiUrl.url}/data-mapping/v1/action-plan/{id}`
        },
        system: {
            save: `${apiUrl.url}/data-mapping/v1/system`,
            listAll: `${apiUrl.url}/data-mapping/v1/system/{accountId}`
        }
    },
    reportsUrl: {
        processesReport: `${apiUrl.url}/data-mapping/v1/reports/process-report`,
        thirdsReport: `${apiUrl.url}/data-mapping/v1/reports/third-report`,
        risksReport: `${apiUrl.url}/data-mapping/v1/reports/risk-appointment-report`,
        systemsReport: `${apiUrl.url}/data-mapping/v1/reports/system-report`,
        actionPlansReport: `${apiUrl.url}/data-mapping/v1/reports/action-plan-report`,
    },
    dashboardUrl: {
        dashboard: `${apiUrl.url}/data-mapping/v1/dashboard-init/infos/{accountId}`
    },
    auditLogsUrl: {
        listAll: `${apiUrl.url}/audit-logs/v1/auditables/organization/{organizationId}/paginated`
    },
    organizationUrl: {
        findInfos: `${apiUrl.url}/user-management/v1/organization`,
        updateInfos: `${apiUrl.url}/user-management/v1/organization/{id}`
    }
}

